import React from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";

const AddNewUserModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered className="create-new-task-modal">
      <div className="p-2">
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="font-20 font-weight-bold heading-color">
              Add New User
            </h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            {/* Row: First Name + Last Name */}
            <Row>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label className="label-input">First Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter first name"
                    className="input-field"
                  />
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label className="label-input">Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter last name"
                    className="input-field"
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Email */}
            <Row className="mt-3">
              <Col lg={12}>
                <Form.Group>
                  <Form.Label className="label-input">Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    className="input-field"
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Row: User Type + User Status */}
            <Row className="mt-3">
              <Col lg={6}>
                <Form.Group>
                  <Form.Label className="label-input">User Type</Form.Label>
                  <Form.Select className="input-field">
                    <option value="admin">Admin</option>
                    <option value="manager">Manager</option>
                    <option value="employee">Employee</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group>
                  <Form.Label className="label-input">User Status</Form.Label>
                  <Form.Select className="input-field">
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {/* Buttons */}
            <Row className="mt-3">
              <Col lg={6}>
                <button
                  type="button"
                  className="c-b-btn w-100"
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </Col>
              <Col lg={6}>
                <button type="submit" className="n-u-btn w-100">
                  Add
                </button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default AddNewUserModal;
